import { Sidebar, SidebarFooter, SidebarMenu, SidebarMenuItem, SidebarContent, SidebarGroup, SidebarGroupLabel, SidebarGroupContent } from '@/shared/components/ui/sidebar'
import { ToggleCard } from '@/components/custom/ToggelCard'
import { useStEditorProvider } from './StEditorProvider'
import { Button } from '@/shared/components/ui/button'
import { Sparkles } from 'lucide-react'
import { useNavigate } from 'react-router-dom'
import { useWorkspace } from '@/features/workspace/stores/workspace.store'
import { useStEditorStore } from '../stores/st-editor.store'

const StEditorOptionbar = ({ ...props }: React.ComponentProps<typeof Sidebar>) => {
    const { featuresEnabled, updateFeatureEnabled } = useStEditorProvider()
    const navigate = useNavigate()
    const { project } = useWorkspace()
    const { storyEntity } = useStEditorStore()

    const handleGenerateScreenplay = () => {
        if (!project?.id) return
        navigate(`/workspace/${project.id}/screenplay`, {
            state: { openGenerationDialog: true, storyContent: storyEntity?.content }
        })
    }

    return (
        <Sidebar
            collapsible="none"
            className="sticky top-0 hidden justify-end h-svh border-l lg:flex"
            {...props}
        >
            <SidebarContent>
                <SidebarGroup>
                    <SidebarGroupLabel>AI Actions</SidebarGroupLabel>
                    <SidebarGroupContent className="p-2">
                        <Button
                            variant="outline"
                            className="w-full justify-start gap-2 border-dashed border-primary/50 hover:border-primary hover:bg-primary/5"
                            onClick={handleGenerateScreenplay}
                        >
                            <Sparkles className="h-4 w-4 text-primary" />
                            <span>Generate Screenplay Outline</span>
                        </Button>
                    </SidebarGroupContent>
                </SidebarGroup>
            </SidebarContent>
            <SidebarFooter>
                <SidebarMenu>
                    <SidebarMenuItem>
                        <ToggleCard
                            id="toggle-node-toolbar"
                            titleEnabled="Node Toolbar shown"
                            titleDisabled="Show Node Toolbar"
                            description="Floating tools at end of lines"
                            checked={featuresEnabled.nodeToolbar}
                            onChange={(checked) => {
                                updateFeatureEnabled({ ...featuresEnabled, nodeToolbar: checked })
                            }}
                        />
                    </SidebarMenuItem>
                </SidebarMenu>
            </SidebarFooter>
        </Sidebar>
    )
}

export default StEditorOptionbar
